import DataContainer from "components/utility/data-container/DataContainer";
import DDiffLaureatesAnimatedExhibit from "./DDiffLaureatesAnimatedExhibit";

const DDiffResearchIsInOurDNAContainer = ({ dataset }) => {
	return (
		<DataContainer data={`ddiffLaureatesAnimatedExhibit_${dataset.guid}`}>
			<DDiffLaureatesAnimatedExhibit />
		</DataContainer>
	);
};

export default DDiffResearchIsInOurDNAContainer;
